import { api, postRequest, postRequestNormal } from "../../server/request";
import { handleError, handleResponse } from "../responseUtil";
import { SET_LOADING, GET_GROUP_SETTINGS_DATA, UPDATE_GROUP_SETTINGS_DATA, CREATE_SMTP_EMAIL_DATA, CREATE_MICROSOFT_GRAPH_EMAIL_DATA, GET_SENDGRID_TABLE_DATA, CREATE_DNS_DATA, VERIFY_DNS_DATA, 
    SEND_TEST_EMAIL, SET_SENDGRID_DATA_LOADING, GET_SMTP_EMAIL_DATA, GET_MICROSOFT_GRAPH_EMAIL_DATA, SMTP_TEST_EMAIL, MS_GRAPH_TEST_EMAIL, SMTP_DATA_DELETE, MSGRAPH_DATA_DELETE, SENDGRID_DATA_DELETE,
    ACTIVATE_SENDGRID, ACTIVATE_SMTP, ACTIVATE_MSGRAPH } from "../types";
import { toast } from "react-toastify";

export const getGroupSettingsData = (dpId) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .getRequest(`/iam/ou/getDpConfiguration/${dpId}`)
        .then((res) => handleResponse(res, dispatch, GET_GROUP_SETTINGS_DATA))
        .catch((err) => handleError(err, dispatch));
};

export const updateOrganizationSettingsData = (dpId, payload) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .putRequest(`/iam/ou/updateDpConfiguration/${dpId}`, payload)
        .then((res) => handleResponse(res, dispatch, UPDATE_GROUP_SETTINGS_DATA))
        .catch((err) => handleError(err, dispatch));
};

export const getSmtpEmailData = (dpId) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .getRequest(`/iam/ou/${dpId}/email/config/smtp`)
        .then((res) => handleResponse(res, dispatch, GET_SMTP_EMAIL_DATA))
        .catch((err) => handleError(err, dispatch));
};

export const createSmtpEmailData = (payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true});
    api
        .postRequest(`/iam/ou/email/config/smtp`, payload)
        .then((res) => handleResponse(res, dispatch, CREATE_SMTP_EMAIL_DATA))
        .catch((err) => handleError(err, dispatch))
}

export const getMicrosoftGraphEmailData = (dpId) => (dispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    api
        .getRequest(`/iam/ou/${dpId}/email/config/msgraph`)
        .then((res) => handleResponse(res, dispatch, GET_MICROSOFT_GRAPH_EMAIL_DATA))
        .catch((err) => handleError(err, dispatch));
};

export const createMicrosoftGraphEmailData = (payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true});
    api
        .postRequest(`/iam/ou/email/config/msgraph`, payload)
        .then((res) => handleResponse(res, dispatch, CREATE_MICROSOFT_GRAPH_EMAIL_DATA))
        .catch((err) => handleError(err, dispatch))
}

export const getSendGridTableData = (dpId) => (dispatch) => {
    dispatch({ type: SET_SENDGRID_DATA_LOADING, payload: true });
    api
        .getRequest(`/iam/ou/${dpId}/email/config/sendgrid`)
        .then((res) => handleResponse(res, dispatch, GET_SENDGRID_TABLE_DATA))
        .catch((err) => handleError(err, dispatch));
};

export const createDNSData = (payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .postRequest(`/iam/ou/email/config/sendgrid`, payload)
        .then((res) => handleResponse(res, dispatch, CREATE_DNS_DATA))
        .catch((err) => handleError(err, dispatch))
}

export const verifyDNSData = (payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api  
        .postRequest(`/iam/ou/email/config/sendgrid/verify`, payload)
        .then((res) => handleResponse(res, dispatch, VERIFY_DNS_DATA))
        .catch((err) => handleError(err, dispatch))
}

export const sendtestEmail = (dpId,payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .postRequest(`/iam/ou/${dpId}/email/config/sendgrid/test`, payload)
        .then((res) => handleResponse(res, dispatch, SEND_TEST_EMAIL))
        .catch((err) => handleError(err, dispatch))
}

export const smtptestEmail = (dpId,payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .postRequest(`/iam/ou/${dpId}/email/config/smtp/test`, payload)
        .then((res) => handleResponse(res, dispatch, SMTP_TEST_EMAIL))
        .catch((err) => handleError(err, dispatch))
}

export const msGraphtestEmail = (dpId,payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .postRequest(`/iam/ou/${dpId}/email/config/msgraph/test`, payload)
        .then((res) => handleResponse(res, dispatch, MS_GRAPH_TEST_EMAIL))
        .catch((err) => handleError(err, dispatch))
}

const showToastMessage = (res, dispatch, handler) => {
    if (res?.data?.status == 1 || res?.data?.success == true) {
        toast.success(res?.data?.message, {
            position: toast.POSITION.BOTTOM_LEFT,
        });
    }
    handleResponse(res, dispatch, handler)
}

export const smtpDataDelete = (dpId, service) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .deleteRequest(`/iam/ou/${dpId}/email/config/delete?emailType=${service}`)
        .then((res) => showToastMessage(res, dispatch, SMTP_DATA_DELETE))
        .catch((err) => handleError(err, dispatch));
}

export const msgraphDataDelete = (dpId, service) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .deleteRequest(`/iam/ou/${dpId}/email/config/delete?emailType=${service}`)
        .then((res) => showToastMessage(res, dispatch, MSGRAPH_DATA_DELETE))
        .catch((err) => handleError(err, dispatch));
}

export const sendGridDataDelete = (dpId, service) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .deleteRequest(`/iam/ou/${dpId}/email/config/delete?emailType=${service}`)
        .then((res) => showToastMessage(res, dispatch, SENDGRID_DATA_DELETE))
        .catch((err) => handleError(err, dispatch));
}

export const activateSendGrid = (dpId,payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .postRequest(`/iam/ou/${dpId}/email/config/activate`, payload)
        .then((res) => showToastMessage(res, dispatch, ACTIVATE_SENDGRID))
        .catch((err) => handleError(err, dispatch))
}

export const activateSmtp = (dpId,payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .postRequest(`/iam/ou/${dpId}/email/config/activate`, payload)
        .then((res) => showToastMessage(res, dispatch, ACTIVATE_SMTP))
        .catch((err) => handleError(err, dispatch))
}

export const activateMsgraph = (dpId,payload) => (dispatch) => {
    dispatch({type: SET_LOADING, payload: true})
     api
        .postRequest(`/iam/ou/${dpId}/email/config/activate`, payload)
        .then((res) => showToastMessage(res, dispatch, ACTIVATE_MSGRAPH))
        .catch((err) => handleError(err, dispatch))
}